<template>
  <wrap class="d_wrap" ref="wrap" title="绑定银行卡">
    <div class="update_password">

      <div class="input_wrap">
        <label>
          <span class="label">持卡人：</span>
          <input type="text" placeholder="持卡人姓名">
        </label>
        <label>
          <span class="label">新密码：</span>
          <select class="select">
            <option>北京银行</option>
            <option>厦门银行</option>
            <option>厦门银行</option>
            <option>厦门银行</option>
          </select>
        </label>
        <label>
          <span class="label">银行卡号：</span>
          <input type="text" placeholder="">
        </label>
        <label>
          <span class="label">开户网点：</span>
          <input type="text" placeholder="">
        </label>
      </div>

      <div class="submit">
        <event tag="button" class="normal-btn t_btn-d active">确认</event>
        <event tag="button" class="normal-btn t_btn-d">重置</event>
      </div>
    </div>
  </wrap>
</template>

<script>
  // qc15复用qc14
  import Wrap from "./wrap";
  import mixin from "./mixin";

  export default {
    name: "QC25",
    mixins: [mixin],
    components: {Wrap},
    data() {
      return {
      };
    },
  }
</script>

<style lang="stylus" scoped>
  .d_wrap{
    font-size 14px
    .update_password{
      top 50%
      left 50%
      position absolute
      padding-bottom 30px
      transform translate(-50%, -50%)
      .input_wrap{
        padding-right 54px
        >label{
          display block
          margin-top 20px
          >.select{
            width 222px
            height 38px
            outline none
            padding-left 5px
            border 1px solid #ddd
          }
          >.label{
            display inline-block
            width 100px
            text-align right
          }
          >input{
            width 200px
            height 38px
            outline none
            border 1px solid #ddd
            padding 0 10px
          }
        }
      }
    }
    .submit{
      text-align center
      margin-top 30px
      >button{
        width 80px
        height 35px
        margin 0 5px
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/QC25.vue